import { create } from 'zustand'
import type { Source, Destination, CrosspointState, Favorites } from '@ultrix/shared'

interface User {
  username: string
  role: 'admin' | 'operator'
}

interface Store {
  user: User | null
  setUser: (u: User | null) => void

  bridgeOnline: boolean
  lastSeen: number
  setBridgeStatus: (online: boolean, lastSeen?: number) => void

  sources: Source[]
  destinations: Destination[]
  state: Map<number, CrosspointState>
  favorites: Favorites

  applySnapshot: (snap: {
    sources: Source[]
    destinations: Destination[]
    state: CrosspointState[]
    favorites: Favorites
    bridgeOnline: boolean
  }) => void
  applyState: (s: CrosspointState) => void
}

export const useStore = create<Store>((set) => ({
  user: null,
  setUser: (u) => set({ user: u }),

  bridgeOnline: false,
  lastSeen: 0,
  setBridgeStatus: (online, lastSeen) => set((prev) => ({ bridgeOnline: online, lastSeen: lastSeen ?? prev.lastSeen })),

  sources: [],
  destinations: [],
  state: new Map(),
  favorites: { sources: [], destinations: [] },

  applySnapshot: (snap) => set({
    sources: snap.sources,
    destinations: snap.destinations,
    state: new Map(snap.state.map((s) => [s.destination, s])),
    favorites: snap.favorites,
    bridgeOnline: snap.bridgeOnline,
    lastSeen: Date.now(),
  }),

  applyState: (s) => set((prev) => {
    const next = new Map(prev.state)
    next.set(s.destination, s)
    return { state: next }
  }),
}))
